export const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
export const phoneReg = /^(1[23456789]\d{9})$/;
export const passwordReg = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;
export const notChinese = /[^\u4E00-\u9FA5]+$/;
export const spaceReg = /^[^\s]*$/;
export const checkSpace = str => {
  return spaceReg.test(str);
};
export const checkPw = str => {
  return passwordReg.test(str) && notChinese.test(str) && checkSpace(str);
};
export const checkComponyEmail = str => {
  let reg = /^[a-zA-Z0-9._%+-]+@(dynatech|dyna)\.ai$/;
  return reg.test(str);
};
export const checkCompanyPassword = value => {
  const lengthValid = value && value.length >= 12 && value.length <= 20;
  const hasNumber = /\d/.test(value);
  const hasLower = /[a-z]/.test(value);
  const hasUpper = /[A-Z]/.test(value);
  const hasSpace = /\s/.test(value);
  const hasChinese = /[\u4e00-\u9fa5]/.test(value);
  return (
    lengthValid && hasNumber && hasLower && hasUpper && !hasSpace && !hasChinese
  );
};
